import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ENVIRONMENT } from '../../../../environment/environment';
import { map, Observable } from 'rxjs';
import { ApiResponse } from '../../models/api-response.model';
import {
    GlobalSearchFilterModel,
    GlobalSearchResultInterface,
    HotTopicInterface,
    HotTopicModel,
    RecentSearchInterface,
} from '../../models/global-search.model';
import { Article, ArticleModel } from '../../models/article.model';
import { Guide, GuideModel } from '../../models/guide.model';
import { News, NewsModel } from '../../models/news.model';
import { CourseListingDetailInterface, CourseListingDetailModel } from '../../models/webinar-course.model';

@Injectable({
    providedIn: 'root',
})
export class GlobalSearchService {
    apiRoute = `${ENVIRONMENT.apiDomain}/api/v1/global-search`;

    constructor(private httpClient: HttpClient) {}

    public getRecentSearch(): Observable<ApiResponse<RecentSearchInterface[]>> {
        return this.httpClient.get<ApiResponse<RecentSearchInterface[]>>(`${this.apiRoute}/recent-search`);
    }

    public getHotTopicList(): Observable<ApiResponse<HotTopicModel[]>> {
        return this.httpClient.get<ApiResponse<HotTopicModel[]>>(`${this.apiRoute}/hot-topic`).pipe(
            map((response) => {
                const responseData = response.result.map((data: HotTopicInterface) => new HotTopicModel(data));
                return { result: responseData };
            }),
        );
    }

    public getGlobalSearchResults(
        filter: GlobalSearchFilterModel,
    ): Observable<ApiResponse<GlobalSearchResultInterface>> {
        return this.httpClient.post<ApiResponse<GlobalSearchResultInterface>>(`${this.apiRoute}/filter`, filter).pipe(
            map((response) => {
                const articlesResult = response.result.articles.data.map(
                    (articles: Article) => new ArticleModel(articles),
                );
                const coursesResult = response.result.courses.data.map(
                    (courses: CourseListingDetailInterface) => new CourseListingDetailModel(courses),
                );
                const quickGuidesResult = response.result.quickGuides.data.map(
                    (quickGuides: Guide) => new GuideModel(quickGuides),
                );
                const taxAMinutesResult = response.result.taxAMinutes.data.map(
                    (taxAMinutes: News) => new NewsModel(taxAMinutes),
                );
                const webinarsResult = response.result.webinars.data.map(
                    (webinars: CourseListingDetailInterface) => new CourseListingDetailModel(webinars),
                );

                return {
                    result: {
                        articles: { ...response.result.articles, data: articlesResult },
                        courses: { ...response.result.courses, data: coursesResult },
                        quickGuides: { ...response.result.quickGuides, data: quickGuidesResult },
                        taxAMinutes: { ...response.result.taxAMinutes, data: taxAMinutesResult },
                        webinars: { ...response.result.webinars, data: webinarsResult },
                    },
                };
            }),
        );
    }

    public deleteRecentSearch(id: number): Observable<ApiResponse<boolean>> {
        return this.httpClient.delete<ApiResponse<boolean>>(`${this.apiRoute}/recent-search/${id}`);
    }

    public deleteAllRecentSearch(): Observable<ApiResponse<boolean>> {
        return this.httpClient.delete<ApiResponse<boolean>>(`${this.apiRoute}/recent-search/all`);
    }
}
